import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LabelSelectorComponent } from './label-selector.component';
import {
	MatChipsModule,
	MatIconModule,
	MatMenuModule,
	MatDividerModule,
	MatTooltipModule,
	MatButtonModule
} from '@angular/material';

@NgModule({
	declarations: [LabelSelectorComponent],
	imports: [
		CommonModule,
		MatChipsModule,
		MatIconModule,
		MatMenuModule,
		MatTooltipModule,
		MatDividerModule,
		MatButtonModule
	],
	exports: [LabelSelectorComponent]
})
export class LabelSelectorModule {}
